import { render, staticRenderFns } from "./RankingRow.vue?vue&type=template&id=40cdc079&scoped=true"
import script from "./RankingRow.vue?vue&type=script&lang=js"
export * from "./RankingRow.vue?vue&type=script&lang=js"
import style0 from "./RankingRow.vue?vue&type=style&index=0&id=40cdc079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cdc079",
  null
  
)

export default component.exports